import { createStore, applyMiddleware, Store } from 'redux';
import rootReducer, { RootState } from '../reducers';
import { ajaxMiddleware } from '../reducers/ajaxmiddleware';
import { composeWithDevTools } from 'redux-devtools-extension';

export function configureStore(initialState?: RootState): Store<RootState> {
	const store = createStore(	rootReducer, 
								initialState, 
								composeWithDevTools(applyMiddleware(ajaxMiddleware as any)) 
							) as Store<RootState>;

	return store;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/store/index.ts